import { useEffect, useRef, useState } from 'react';
import claudeSprites from '@/assets/claude-sprites.json';

type AnimState = 'writing' | 'shimmer' | 'orbiting';

interface ClaudeLoaderProps {
  size?: number;
  state?: AnimState;
}

export default function ClaudeLoader({ size = 28, state = 'writing' }: ClaudeLoaderProps) {
  const [currentState, setCurrentState] = useState<AnimState>(state);
  const [frame, setFrame] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval>>();

  // Auto-cycle: writing → shimmer → orbiting
  useEffect(() => {
    const cycle: AnimState[] = ['writing', 'shimmer', 'orbiting'];
    let idx = 0;
    const timer = setInterval(() => {
      idx = (idx + 1) % cycle.length;
      setCurrentState(cycle[idx]);
    }, 2500);
    return () => clearInterval(timer);
  }, []);

  const anim = claudeSprites[currentState];
  const frameHeight = 100; // Each frame is 100px in the viewBox

  useEffect(() => {
    setFrame(0);
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setFrame((f) => (f + 1) % anim.frameCount);
    }, anim.speed);
    return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
  }, [currentState, anim.frameCount, anim.speed]);

  // Clip to show only the current frame from the vertical sprite sheet
  const viewBoxY = frame * frameHeight;

  // Rewrite viewBox to clip to current frame AND inject fill color on all paths
  const patchedSvg = anim.svg
    .replace(/viewBox="[^"]*"/, `viewBox="0 ${viewBoxY} 100 ${frameHeight}"`)
    .replace(/<svg/, `<svg style="width:${size}px;height:${size}px"`)
    .replace(/<path /g, `<path fill="#D97757" `);

  return (
    <div
      className="inline-block"
      style={{ width: size, height: size }}
      dangerouslySetInnerHTML={{ __html: patchedSvg }}
    />
  );
}
